@if (variant(); as variant) {
  <!-- Auto-height reserves only 150px of grid body, so this stays compact enough not to overflow it.
       The extra top padding offsets the horizontal scrollbar the overlay is centred against, which
       otherwise leaves the message sitting visibly high in the band. -->
  <div class="gap-sm p-md pt-4xl flex flex-col items-center justify-center text-center">
    <bx-featured-icon-outline size="md" [icon]="variant.icon" [color]="variant.color"></bx-featured-icon-outline>

    <p class="text-text-primary-900 text-sm font-semibold">{{ variant.title | translate }}</p>
    <p class="text-text-tertiary-600 text-sm">{{ variant.message | translate }}</p>

    @if (showsRetry()) {
      <button bx-button type="secondary-gray" size="sm" (click)="handleRetryClick()">
        {{ 'product-view.property-overview.error.retry' | translate }}
      </button>
    }
  </div>
}
